import baseStaticConfig from './base';
import deepMerge from 'deepmerge';
import { Networks, Network, WalletType } from '@types';

const publicStaticConfig = deepMerge(baseStaticConfig, {
  networks: {
    testnet: {
      [Network.Ethereum]: {
        disabled: false,
        toNetworks: {
          [Network.Cronos]: {
            disabled: false,
            addressInput: false,
          },
        },
      },
      [Network.CryptoOrg]: {
        disabled: true,
        hide: true,
        toNetworks: {
          [Network.Cronos]: {
            disabled: true,
            addressInput: true,
          },
        },
      },
      [Network.Cronos]: {
        disabled: false,
        toNetworks: {
          [Network.CryptoOrg]: {
            disabled: true,
            hide: true,
            addressInput: true,
          },
          [Network.Ethereum]: {
            disabled: false,
            addressInput: false,
          },
        },
      },
    } as Networks,
    mainnet: {
      [Network.Ethereum]: {
        disabled: true,
        toNetworks: {
          [Network.Cronos]: {
            disabled: true,
            addressInput: false,
          },
        },
      },
      [Network.CryptoOrg]: {
        disabled: false,
        toNetworks: {
          [Network.Cronos]: {
            disabled: false,
            addressInput: true,
          },
        },
      },
      [Network.Cronos]: {
        disabled: false,
        toNetworks: {
          [Network.CryptoOrg]: {
            disabled: false,
            addressInput: true,
          },
          [Network.Ethereum]: {
            disabled: true,
            addressInput: false,
          },
        },
      },
    } as Networks,
  },
  walletSupportedNetworks: {
    mainnet: {
      [WalletType.deficonnect]: [Network.Cronos, Network.CryptoOrg],
      [WalletType.keplr]: [Network.CryptoOrg],
      [WalletType.metamask]: [Network.Cronos],
    },
  },
});

export default publicStaticConfig;
